export default {
  progress: 'Saving…',
  success: 'Changes saved!',
  error: 'Unable to save changes.',
};
